import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PAGES } from "@/lib/nav";

const HOME_META = {
  title: "TytoCare Italia · Visite mediche assistite a domicilio",
  description:
    "Un infermiere raggiunge il tuo domicilio con TytoCare e un medico generalista o specialista effettua la visita in diretta. Richiedi su WhatsApp.",
};

const META = Object.fromEntries(
  PAGES.map((p) => [
    p.path,
    { title: `${p.label} · TytoCare Italia`, description: p.desc },
  ])
);

Object.assign(META, {
  "/privacy-policy": {
    title: "Privacy Policy · TytoCare Italia",
    description: "Informativa sul trattamento dei dati personali ai sensi del GDPR.",
  },
  "/termini-e-condizioni": {
    title: "Termini e Condizioni · TytoCare Italia",
    description: "Condizioni generali del servizio di visite mediche assistite a domicilio.",
  },
  "/cookie-policy": {
    title: "Cookie Policy · TytoCare Italia",
    description: "Informativa sull'uso dei cookie del sito TytoCare Italia.",
  },
});

export default function RouteMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = META[pathname] || HOME_META;
    document.title = meta.title;
    const description = meta.description || HOME_META.description;
    const canonical = `https://tytocare.it${pathname === "/" ? "/" : pathname}`;

    const setMeta = (attr, key, content) => {
      let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", meta.title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);
    setMeta("name", "twitter:title", meta.title);
    setMeta("name", "twitter:description", description);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }, [pathname]);

  return null;
}
